module.exports = __webpack_public_path__ + "assets/check.70b94159.svg";